export enum FeatureToggle {
  ModalystSetupByProductList = 'ggAiStoreBuilderModalystSetupByProductList',
  CreateSitelessSiteFromTemplate = 'ggAiStoreBuilderCreateSitelessSiteFromTemplate',
}

export const featureToggleIds: string[] = [
  FeatureToggle.ModalystSetupByProductList,
  FeatureToggle.CreateSitelessSiteFromTemplate,
];
